import { render, staticRenderFns } from "./wrapperPROList.vue?vue&type=template&id=4c7c82c3&"
import script from "./wrapperPROList.vue?vue&type=script&lang=js&"
export * from "./wrapperPROList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports